import { render, staticRenderFns } from "./BankAccountsList.vue?vue&type=template&id=68cd2873&"
import script from "./BankAccountsList.vue?vue&type=script&lang=js&"
export * from "./BankAccountsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports